<i18n src="./translations"></i18n>

<template>
  <component
    :is="type"
    :href="url"
    :class="classes"
    :data-preload="[$options.name]"
    @click="onClickHandler"
  >
    <div v-if="topCategories || !!icon" class="iconWrap">
      <Icon
        :name="
          topCategories ? 'thumb_up' : icon && icon.replace('catalog/', '')
        "
        width="20"
        height="20"
      />
    </div>
    <span class="label">
      {{ topCategories ? $t('category-list-item.top_categories') : title }}
    </span>
    <Icon
      v-if="showArrow"
      class="chevron"
      name="chevron_right"
      width="25"
      height="25"
    />
  </component>
</template>

<script>
import noop from 'lodash/noop';
import Icon from 'Components/00-generated/Icon';
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'CategoryListItem',
  components: {
    Icon,
  },
  mixins: [globalMixin],
  props: {
    type: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    onClickHandler: {
      type: Function,
      default: noop,
    },
    topCategories: {
      type: Boolean,
      default: false,
    },
    showArrow: {
      type: [String, Boolean],
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
@import 'variables/breakpoints';
@import 'mixins';

.categoryListItem {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  padding-left: var(--space-2);
  cursor: pointer;
}

.iconWrap {
  width: 20px;
  margin-right: var(--space-2);
  color: var(--color-rolling-stone);

  svg {
    margin: 0 auto;
  }
}

.label {
  text-align: left;
  flex-grow: 1;
}

.chevron {
  margin-left: auto;
  margin-right: var(--space-1);
  flex-shrink: 0;

  color: var(--color-primary);
}

.categoryListItem[selected] .label {
  font-weight: 700;
  background-color: var(--color-wild-sand);
}
</style>
